export default __webpack_public_path__ + "static/media/hexagon-inner-3.51e49c14.svg";